module.exports = __webpack_public_path__ + "28170e0e1de883ef131dd17c10f09103.jpeg";